import { render, staticRenderFns } from "./CustomerAccount.vue?vue&type=template&id=19ed6b0b&"
import script from "./CustomerAccount.vue?vue&type=script&lang=js&"
export * from "./CustomerAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports